module.exports = [{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-manifest@2.4.2_gatsby@2.25.0_@types+node@25.3.3_@types+webpack@4.41.40_bu_e9509def3adac85769610f7ccda11b2a/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"flexa-network","short_name":"flexa","start_url":"/","background_color":"#ffffff","theme_color":"#485dff","display":"minimal-ui","icon":"src/images/logos/flexa-logo@3x.png"},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-typography@2.5.1_gatsby@2.25.0_@types+node@25.3.3_@types+webpack@4.41.40__9c0c3e227a6d1febb131973e9c53216d/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
